/**
 * A wrapper around react-components/info-tip.jsx that can be rendered on the
 * server without causing a checksum mismatch on the client.
 * (RCSS generates classnames with a randomSuffix, which ensures that any
 * two sets of generated classnames will not match.)
 */

var React = require("react");

var ReactComponentsInfoTip = require("react-components/info-tip.jsx");

var InfoTip = React.createClass({
    displayName: "InfoTip",

    getInitialState: function getInitialState() {
        return {
            didMount: false
        };
    },

    componentDidMount: function componentDidMount() {
        /* eslint-disable react/no-did-mount-set-state */
        this.setState({ didMount: true });
        /* eslint-enable react/no-did-mount-set-state */
    },

    render: function render() {
        if (this.state.didMount) {
            return React.createElement(ReactComponentsInfoTip, this.props);
        } else {
            return React.createElement("div", null);
        }
    }
});

module.exports = InfoTip;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/info-tip.jsx
 ** module id = 176
 ** module chunks = 0 2
 **/